import { MIN_MONEY_WITHDRAW, SystemMessage } from "@app/constants";
import * as Yup from "yup";

export const createWithdrawValidationSchema = Yup.object().shape({
  money: Yup.number()
    .typeError("Nhập số tiền hợp lệ")
    .integer("Nhập số nguyên")
    .min(MIN_MONEY_WITHDRAW, "Số tiền rút từ 10.000đ")
    .required(SystemMessage.INPUT_REQUIRED),
});
